<template>
  <div class="emptyBox">
    <Row type="flex" style="text-align: center;">
      <Col span="24"><img class="emptyImg" src="/static/images/empty.png" alt=""></Col>
      <Col span="24" style="margin-top:20px;">暂时没有相关内容～</Col>
    </Row>
  </div>
</template>

<script>
export default {
  name:'Empty',
  props:{
    noLogin:{
      typr:String,
      default:''
    }
  }
}
</script>

<style scoped>
  .emptyImg {
    margin-top: 100px;
    width: 320px;
  }
  .emptyBox{
    min-height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Empty/Empty.vue